// extracted by mini-css-extract-plugin
module.exports = {"oneTapContainer":"OneTapContainer_oneTapContainer__JwUN7"};